import React from 'react';
import PropTypes from 'prop-types';

import { pure } from '@dbk/ui-react-utils';
import Text from '../../../common/text';
import { NO_DATA } from '../../../../constants';
import { ChangeIndicatedPercent } from '../../../common/number';

function AssetItemHeaderChange(props) {
  let { value } = props;

  if (value === null) {
    return <Text>{NO_DATA}</Text>
  }

  if (typeof value !== 'number') {
  	value = 0;
  }
  return (
    <ChangeIndicatedPercent value={value} withPlusSign />
  );
}

AssetItemHeaderChange.propTypes = {
  value: PropTypes.number,
};

export default pure(AssetItemHeaderChange);
